import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const premiseUserAttendanceList = createAsyncThunk('premiseUserAttendance/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_staff_attendance`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                role_id: data?.role_id,
                premise_id: data?.premise_id,
                in_time: data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                user_id: data?.premise_user_id,
                fDate: data?.fDate || undefined,
                tDate: data?.tDate || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const premiseUserAttendanceCalendar = createAsyncThunk('premiseUserAttendance/calendar', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `premise_staff_calendar`,
            params: {
                user_id: data?.premise_user_id,
                month: data?.month,
                year: data?.year,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const markPremiseUserAttendance = createAsyncThunk('premiseUserAttendance/mark', async ({ attendance_id, attendance_status }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `mark_attendance`,
            data: {
                attendance_id,
                attendance_status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const premiseUserAttendance = createSlice({
    name: 'premiseUserAttendance',
    initialState: {
        list: [],
        calendarData: null,
        loading: false,
        calendarLoading: false,
    },
    reducers: {
        resetPremiseUserCalendarData: (state) => {
            state.calendarData = null
        },
    },
    extraReducers: (builder) => {
        builder.addCase(premiseUserAttendanceList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(premiseUserAttendanceCalendar.pending, (state) => {
            state.calendarLoading = true;
        });
        builder.addCase(premiseUserAttendanceCalendar.fulfilled, (state, action) => {
            state.calendarLoading = false;
            if (action?.payload?.status === 200) {
                state.calendarData = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.calendarData = null
            }
        });
        builder.addCase(premiseUserAttendanceCalendar.rejected, (state) => {
            state.calendarLoading = false;
            state.calendarData = null;
        });
    }
})

export const { resetPremiseUserCalendarData } = premiseUserAttendance.actions;
export default premiseUserAttendance.reducer;